<div class="outer-box">
    <div class="global-table no-radius p0">
        <div class="tab-content1">
            <div class="tab-pane1">
                <div class="table-responsive">
                    <table class="table table-bordered" aria-describedby="user list">
                        <thead>
                            <tr class="no_wrap_th">
                                <th scope="col">Commission Value</th>
                                <th scope="col">Commission Percentage</th>
                                <th scope="col">Action</th>

                            </tr>
                        </thead>
                        <tbody>
                            <ng-container>
                                <tr>
                                    <td *ngIf="!cointAmount">{{commsiionValue}}</td>
                                    <td *ngIf="cointAmount">
                                        <input [value]="commsiionValue" [(ngModel)]="commsiionValue"
                                            (keypress)="service.preventSpace($event);" step="0.1" type="number"
                                            style="text-align: left;" maxlength="12" placeholder="USD Price"
                                            class="form-control">
                                    </td>

                                    <td>{{coinList?.percentage}}</td>
                                    <td>
                                        <button *ngIf="!cointAmount" type="submit" class="btn  btn-theme cus-mr"
                                            (click)="enableInputField()" style="width: 88%;">Edit</button>
                                        <button *ngIf="cointAmount" type="submit" class="btn  btn-theme cus-mr"
                                            (click)="updateCoinAmount(commsiionValue)"
                                            style="width: 88%;">Update</button>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</div>